import RootStore from './RootStore';
import { setRootStore } from '.';

export function initStore(): void {
  const rootStore = new RootStore();
  setRootStore(rootStore);
}
